'use client'

import { useEffect } from 'react'

export type SalesForceFormProps = {
	formUrl: string
	notes?: string
}

const SalesForceForm = ({ formUrl, notes }: SalesForceFormProps) => {
	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	}, [])

	return (
		<>
			<p>
				<iframe
					src={`${formUrl}${notes ? `?ITBA_Person_Notes=${encodeURIComponent(notes)}` : ''}`}
					width="100%"
					height="1800px"
					allowTransparency={true}
					style={{ border: '0' }}
					id="test-frame"
				></iframe>
			</p>
		</>
	)
}

SalesForceForm.displayName = 'SalesForceForm'

export default SalesForceForm
